import { render, staticRenderFns } from "./tkcarorders.vue?vue&type=template&id=c689e51a&scoped=true"
import script from "./tkcarorders.vue?vue&type=script&lang=js"
export * from "./tkcarorders.vue?vue&type=script&lang=js"
import style0 from "./tkcarorders.vue?vue&type=style&index=0&id=c689e51a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c689e51a",
  null
  
)

export default component.exports